'use client';

import { useContext } from 'react';
import { Toast } from './Toast';
import { ToastContext } from './ToastContext';

export function ToastContainer() {
    const context = useContext(ToastContext);

    if (!context) {
        return null;
    }

    const { toasts, removeToast } = context;

    if (toasts.length === 0) {
        return null;
    }

    return (
        <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
            {toasts.map(toast => (
                <Toast key={toast.id} toast={toast} onClose={removeToast} />
            ))}
        </div>
    );
}
